import React from 'react';
import cn from 'classnames';
import { Icon, Image, Link, Title } from '@landing/ui';

import * as styles from './LocationCard.module.scss';

export default function LocationCard({ title, date, link, image, finished, className }) {
  const Wrapper = link ? Link : 'div';
  const parsedDate = new Date(date).toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  return (
    <Wrapper className={cn(styles.card, className)} href={link} target={null}>
      <Image className={styles.picture} classImage={styles.img} src={image} />
      <div className={styles.contentWrapper}>
        <div className={styles.tag}>{finished ? 'Past' : 'Upcoming'}</div>
        <Title className={styles.title} tag="h3" color="white">
          {title}
        </Title>
        <div className={styles.details}>
          <div className={styles.date}>
            <Icon name="calendar" className={styles.dateIcon} />
            <span>{parsedDate}</span>
          </div>
          {link && <span className={styles.link}>Event details</span>}
        </div>
      </div>
    </Wrapper>
  );
}
